// Hindi seed dictionary for instant first-paint. The runtime DOM translator
// (I18nContext) merges this into its cache and fills any remaining strings via
// the Sarvam-backed /api/i18n/translate endpoint. Hand-corrected for UI context.
export const I18N_SEED = {
  "Rewards": "रिवॉर्ड्स",
  "Family": "परिवार",
  "Profile": "प्रोफ़ाइल",
  "Home": "होम",
  "Shop": "दुकान",
  "Search": "खोजें",
  "Sign in": "साइन इन करें",
  "Sign up": "साइन अप करें",
  "Log in": "लॉग इन करें",
  "Log out": "लॉग आउट करें",
  "Login": "लॉगिन",
  "Register": "रजिस्टर करें",
  "Logout": "लॉग आउट",
  "Email": "ईमेल",
  "Mobile number": "मोबाइल नंबर",
  "Password": "पासवर्ड",
  "Name": "नाम",
  "Continue": "जारी रखें",
  "Submit": "सबमिट करें",
  "Forgot password?": "पासवर्ड भूल गए?",
  "Create account": "खाता बनाएँ",
  "Already have an account?": "क्या आपका पहले से खाता है?",
  "Buy Now": "अभी खरीदें",
  "Add to cart": "कार्ट में जोड़ें",
  "Cart": "कार्ट",
  "Checkout": "चेकआउट",
  "Order": "ऑर्डर",
  "Orders": "ऑर्डर",
  "Delivery": "डिलीवरी",
  "Pickup": "पिकअप",
  "Price": "कीमत",
  "Total": "कुल",
  "Quantity": "मात्रा",
  "Out of stock": "स्टॉक में नहीं",
  "In stock": "स्टॉक में उपलब्ध",
  "View details": "विवरण देखें",
  "Products": "उत्पाद",
  "Categories": "श्रेणियाँ",
  "Map view": "मैप व्यू",
  "List view": "लिस्ट व्यू",
  "No products match your search": "आपकी खोज से कोई उत्पाद मेल नहीं खाता",
  "found": "मिले",
  "Showing shops near you": "आपके पास की दुकानें दिखा रहे हैं",
  "Nearby shops": "आस-पास की दुकानें",
  "Filter": "फ़िल्टर",
  "Sort": "क्रमबद्ध करें",
  "All": "सभी",
  "Popular": "लोकप्रिय",
  "New": "नया",
  "Please wait": "कृपया प्रतीक्षा करें",
  "Loading...": "लोड हो रहा है...",
  "Save": "सहेजें",
  "Cancel": "रद्द करें",
  "Close": "बंद करें",
  "Confirm": "पुष्टि करें",
  "Delete": "हटाएँ",
  "Edit": "संपादित करें",
  "Next": "अगला",
  "Back": "वापस",
  "Done": "हो गया",
  "Retry": "पुनः प्रयास करें",
  "Try again": "फिर कोशिश करें",
  "Yes": "हाँ",
  "No": "नहीं",
  "OK": "ठीक है",
  "Share": "साझा करें",
  "Copy": "कॉपी करें",
  "Send": "भेजें",
  "Apply": "लागू करें",
  "Something went wrong": "कुछ गड़बड़ हो गई",
  "Try again later": "बाद में पुनः प्रयास करें",
  "Health": "स्वास्थ्य",
  "Rewards points": "रिवॉर्ड पॉइंट्स",
  "Points": "पॉइंट्स",
  "Wallet": "वॉलेट",
  "Balance": "बैलेंस",
  "Book now": "अभी बुक करें",
  "Reminders": "रिमाइंडर",
  "Settings": "सेटिंग्स",
  "Help": "मदद",
  "About": "परिचय",
  "Hold to speak": "बोलने के लिए दबाए रखें",
  "Tap to speak": "बोलने के लिए टैप करें",
  "Searching...": "खोज रहे हैं...",
  "Speak to search": "बोलकर खोजें"
};
